import { render, staticRenderFns } from "./UjianHasil.vue?vue&type=template&id=4ba52a2a&scoped=true"
import script from "./UjianHasil.vue?vue&type=script&lang=js"
export * from "./UjianHasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba52a2a",
  null
  
)

export default component.exports